import AccessDeniedPage from "@/views/access-denied/access-denied.vue";
import DisconnectIssuePage from "@/views/disconnect-issue/disconnect-issue.vue";
import LoadingPage from "@/views/loading/loading.vue";
import NotFoundPage from "@/views/not-found/not-found.vue";
import "cropperjs/dist/cropper.css";
import { createApp } from "vue";
import VueCropper from "vue-cropperjs";
import VueFinalModal from "vue-final-modal";
import { BaseButton, BaseCard, BaseIcon, BaseTag, GLPlugin, MatIcon, VueSite } from "vue-glcommonui";
import * as GLCommonUI from "vue-glcommonui";
import Lottie from "vue-lottie";
import App from "./app/app.vue";
import {
  AnnotationView,
  CloseSquareIcon,
  ConnectAvatar,
  CropImage,
  CustomSpinner,
  LiveCircle,
  PinningModal,
  Toast,
  VideoPlaceholder,
  InOneIcon,
  CustomSelect,
  DeviceSetting,
  MicrophoneIcon,
  LessonGallery,
  DeviceSettingModal,
  DeviceErrorTooltip,
} from "./components/common";
import { ClickOutsideDirective } from "./directives";
import router from "./router";
import { store } from "./store";
import "./style/main.less";
import i18n, { loadAsyncLocale, persistLocale } from "./utils/i18n";
import { Paths } from "./utils/paths";
import * as Sentry from "@sentry/vue";
const app = createApp(App);
const tenantBootstrap = (GLCommonUI as any).bootstrapTenant;
if (typeof tenantBootstrap === "function") {
  tenantBootstrap({
    url: window.location.href,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    hash: window.location.hash,
  });
}
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    enabled: process.env.VUE_APP_ENVIRONMENT !== "local",
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: process.env.VUE_APP_VERSION,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: false,
    ignoreErrors: [/login_required/i, /ErrorResponse:\s*login_required/i],

    beforeSend(event) {
      const values = event.exception?.values || [];
      const msg = [event.message || "", ...values.map((v) => `${v.type || ""}: ${v.value || ""}`)].join(" | ");

      if (/login_required/i.test(msg)) {
        return null;
      }
      return event;
    },
  });
}

app.directive("click-outside", ClickOutsideDirective);
app.component("LoadingPage", LoadingPage);
app.component("AccessDeniedPage", AccessDeniedPage);
app.component("DisconnectIssuePage", DisconnectIssuePage);
app.component("NotFoundPage", NotFoundPage);
app.component("BaseIcon", BaseIcon);
app.component("BaseButton", BaseButton);
app.component("BaseCard", BaseCard);
app.component("BaseTag", BaseTag);
app.component("LiveCircle", LiveCircle);
app.component("Toast", Toast);
app.component("AnnotationView", AnnotationView);
app.component("PinningModal", PinningModal);
app.component("CustomSpinner", CustomSpinner);
app.component("VideoPlaceholder", VideoPlaceholder);
app.component("Lottie", Lottie);
app.component("CropImage", CropImage);
app.component("VueCropper", VueCropper);
app.component("MatIcon", MatIcon);
app.component("ConnectAvatar", ConnectAvatar);
app.component("CloseSquareIcon", CloseSquareIcon);
app.component("InOneIcon", InOneIcon);
app.component("CustomSelect", CustomSelect);
app.component("DeviceSetting", DeviceSetting);
app.component("MicrophoneIcon", MicrophoneIcon);
app.component("LessonGallery", LessonGallery);
app.component("DeviceErrorTooltip", DeviceErrorTooltip);
app.component("DeviceSettingModal", DeviceSettingModal);
app.use(store);
app.use(VueFinalModal(), {});
//vue-glcommonui plugin
app.use(GLPlugin, {
  i18nInstance: i18n,
  store,
  appConfig: process.env,
  option: {
    persistLocale,
    loadAsyncLocale,
    vueSite: VueSite.GSConnect,
  },
});
app.use(router);

// Global properties
app.config.globalProperties.$paths = Paths;

app.mount("#app");
